import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Input } from "@/components/ui/input";
import { AuthShell } from "@/components/AuthShell";
import { Field, GradButton } from "@/components/erp";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to={user.role === "bayi" ? "/bayi" : "/"} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      const u = await login(email, password);
      nav(u.role === "bayi" ? "/bayi" : "/");
    } catch (ex) {
      setErr(errMsg(ex));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title="Giriş yap" desc="Hesabınız yöneticiniz tarafından oluşturulur.">
      <form onSubmit={submit} className="space-y-5" data-testid="login-form">
        <Field label="E-posta veya kullanıcı adı">
          <Input data-testid="login-email" type="text" autoCapitalize="none" autoCorrect="off" required value={email} onChange={(e) => setEmail(e.target.value)} className="h-11 bg-white/5" />
        </Field>
        <Field label="Şifre">
          <Input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="h-11 bg-white/5" />
        </Field>
        {err && <div data-testid="login-error" className="text-sm text-red-400">{err}</div>}
        <GradButton type="submit" disabled={busy} data-testid="login-submit" className="w-full justify-center h-11">
          {busy ? "Giriş yapılıyor…" : "Giriş yap"} <ArrowRight className="w-4 h-4" />
        </GradButton>
        <Link to="/forgot-password" data-testid="forgot-link" className="block text-center text-sm text-muted-foreground hover:text-white transition-colors">
          Şifremi unuttum
        </Link>
        <Link to="/bayi-basvuru" data-testid="bayi-basvuru-link" className="block text-center text-sm text-muted-foreground hover:text-white transition-colors">
          Bayimiz olmak ister misiniz? <span className="grad-text font-medium">Bayi başvurusu yapın</span>
        </Link>
      </form>
    </AuthShell>
  );
}
